import { DateTime } from '@vgn-medien-holding/vgn-fe-components';

export interface ArticleDateProps {
  createdDate: Date;
  updatedDate?: Date;
  hideUpdatedAt?: boolean;
}

export const ArticleDate = ({ createdDate, updatedDate, hideUpdatedAt }: ArticleDateProps) => {
  return (
    <p className={'text-gray-500'}>
      <span>
        Ver&ouml;ffentl. am <DateTime date={createdDate} formatOptions={{ dateStyle: 'medium' }} />
      </span>
      {updatedDate && !hideUpdatedAt && (
        <>
          <span> / Aktualisiert am </span>
          <DateTime classProps={{ root: 'font-bold' }} date={updatedDate} formatOptions={{ dateStyle: 'medium' }} />
        </>
      )}
    </p>
  );
};
